import { api } from "@/lib/api";

export const purchaseApi = {
  meta: () => api.get("/purchase/meta").then((r) => r.data),
  stats: () => api.get("/purchase/stats").then((r) => r.data),
  suppliers: () => api.get("/purchase/suppliers").then((r) => r.data),
  materials: () => api.get("/purchase/materials").then((r) => r.data),
  listPO: (params) => api.get("/purchase/orders", { params }).then((r) => r.data),
  getPO: (id) => api.get(`/purchase/orders/${id}`).then((r) => r.data),
  createPO: (body) => api.post("/purchase/orders", body).then((r) => r.data),
  updatePO: (id, body) => api.put(`/purchase/orders/${id}`, body).then((r) => r.data),
  setPOStatus: (id, status) => api.patch(`/purchase/orders/${id}/status`, { status }).then((r) => r.data),
  listGRN: (params) => api.get("/purchase/grn", { params }).then((r) => r.data),
  createGRN: (body) => api.post("/purchase/grn", body).then((r) => r.data),
};

export const PO_STATUS_STYLE = {
  Draft: "bg-slate-100 text-slate-700",
  Approved: "bg-blue-50 text-blue-700 border border-blue-200",
  Sent: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  "Partially Received": "bg-amber-50 text-amber-700 border border-amber-200",
  Completed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Cancelled: "bg-rose-50 text-rose-700 border border-rose-200",
};

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
